import { useAtomValue, useResetAtom, useSetAtom } from '~shared/lib/atom-state';

import { orgInfoAtom, setOrgInfoAtom } from './atoms';

export const useOrgInfo = () => {
  return useAtomValue(orgInfoAtom);
};

export const useSetOrgInfo = () => {
  return useSetAtom(setOrgInfoAtom);
};

export const useResetOrgInfo = () => {
  return useResetAtom(orgInfoAtom);
};
